export type NavItem = {
  id: string
  title: string
  path: string
  subItems?: [{ id: string; title: string; path: string }]
}

type SplittedNavItem = {
  firstPart: NavItem[]
  secondPart: NavItem[]
}

export const navItems: NavItem[] = [
  {
    id: 'competition_declarations',
    title: 'Müsabiqə elanları',
    path: '/competitions',
  },
  {
    id: 'procurement_plans',
    title: 'Satınalma planları',
    path: '/purchase-plans',
  },
  {
    id: 'contracts',
    title: 'Bağlanmış müqavilələr',
    path: '/concluded-contracts',
  },
  {
    id: 'notifications',
    title: 'Bildirişlər',
    path: '/notifications',
  },
  {
    id: 'news',
    title: 'Xəbərlər',
    path: '/news',
  },
  {
    id: 'faq',
    title: 'Tez-tez verilən suallar',
    path: '/faq',
  },
  {
    id: 'reports',
    title: 'Hesabat',
    path: '/reports',
  },
  // {
  //   id: 'videoInstructions',
  //   title: 'Təlimatlar',
  //   path: '/instructions',
  // },
  {
    id: 'contact',
    title: 'Əlaqə',
    path: '/contact',
  },
]

export const splittedNavItems: SplittedNavItem = {
  firstPart: [
    {
      id: 'competition_declarations',
      title: 'Müsabiqə elanları',
      path: '/competitions',
    },
    {
      id: 'procurement_plans',
      title: 'Satınalma planları',
      path: '/purchase-plans',
    },
    {
      id: 'contracts',
      title: 'Bağlanmış müqavilələr',
      path: '/concluded-contracts',
    },
    {
      id: 'notifications',
      title: 'Bildirişlər',
      path: '/notifications',
    },
    {
      id: 'news',
      title: 'Xəbərlər',
      path: '/news',
    },
  ],
  secondPart: [
    {
      id: 'faq',
      title: 'Tez-tez verilən suallar',
      path: '/faq',
    },
    {
      id: 'reports',
      title: 'Hesabat',
      path: '/reports',
    },
    {
      id: 'videoInstructions',
      title: 'Təlimatlar',
      path: '/instructions',
    },
    {
      id: 'contact',
      title: 'Əlaqə',
      path: '/contact',
    },
  ],
}
